import { FormControl, IconButton, useTheme, InputAdornment } from '@mui/material';
import TextField from '@mui/material/TextField';
import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';
import { useState, useRef } from 'react';

function TableSearchWithIcon({
  changeSearch,
  deafultSearchValue = '',
  searchType = 'Normal',
  width = '90%',
  label='search',
  searchWithEnter=true
}) {
  const [shrinkFlag, setShrinkFlag] = useState(false);
  const [searchValue, setSearchValue] = useState(deafultSearchValue);
  const theme = useTheme();

  // Track last searched text
  const lastSearchedValue = useRef('');

  const removeSearch = () => {
    setSearchValue('');
    setShrinkFlag(false);
    lastSearchedValue.current = '';

    // 🔥 Send empty string + fresh triggerId
    changeSearch({
      text: '',
      triggerId: Date.now(),
    });
  };

  const handleSearchTrigger = () => {
    const trimmed = searchValue.trim();

    // 🔥 Allow same text searches anytime
    lastSearchedValue.current = trimmed;

    changeSearch({
      text: trimmed,
      triggerId: Date.now(), // unique ID → always triggers
    });
  };

  return (
    <FormControl fullWidth variant="outlined">
      <TextField
        autoComplete="off"
        label={label}
        sx={{ width }}
        size="small"
        name={label}
        value={searchValue}
        onFocus={() => setShrinkFlag(true)}
        onBlur={(e) => setShrinkFlag(!!e.target.value)}
        InputLabelProps={{
          shrink: shrinkFlag,
        }}
        onChange={(event) => setSearchValue(event.target.value)}
        onKeyDown={(e) => {
          if (e.key === 'Enter' && searchWithEnter) {
            handleSearchTrigger();
          }
        }}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              {/* Clear Button */}
              <IconButton
                sx={{
                  visibility: searchValue ? 'visible' : 'hidden',
                  '&:hover': {
                    background: theme.colors?.error?.lighter || '#fdecea',
                  },
                  color: theme.palette.error.main,
                  mr: 0.5,
                }}
                size="small"
                onClick={removeSearch}
              >
                <CloseIcon />
              </IconButton>

              {/* Search Button */}
              <IconButton
                color="primary"
                size="small"
                onClick={handleSearchTrigger}
              >
                <SearchIcon />
              </IconButton>
            </InputAdornment>
          ),
        }}
      />
    </FormControl>
  );
}

export default TableSearchWithIcon;
